import { api } from '@/api/common/instances';

const state = {
  monitors: [],
  targets: {},
};

const getters = {
  /**
   * Commented.by.KWShin.2024.03.04.
   * state.targets 에는 owlens-model 프로젝트의 enumtype Chart/Grid의 name:monitorCode 쌍이 들어 있다.
   * UI 작성자는 Chart/Grid enumtype의 name의 값을 monitorCode라는 변수에 담아 사용하고 있다.
   * 원래 monitorCode는 enumtype의 name을 지칭하는 것이 아니므로 혼동을 초래한다.
   * 아래코드에서 state.targets[monitorCode] 부분의 monitorCode에는 enumtype name이 들어온다.
   * 예를 들어, getMonitor('KE5', 'C_PCAP_OS_CPU')를 호출하면,
   * 원래 의미의 monitorCode 'A_OS___PCAP'에 해당하는 CONF_MNTR/CONF_MNTR_SSTM 테이블 값이 리턴된다.
   * 즉, state.targets에는 { ..., "C_PCAP_OS_CPU": "A_OS___PCAP", ...} 형식으로 데이터가 들어가 있다.
   */
  getMonitor(state) {
    return (systemId, monitorCode) => state.monitors.find(m => m.code == state.targets[monitorCode] && m.systemId == systemId);
  },
};

const mutations = {
  setMonitors(state, monitors) {
    state.monitors = monitors;
  },
  setTargets(state, targets) {
    state.targets = targets;
  },
};

const actions = {
  async fetchMonitors({ commit }) {
    const { data } = await api.get('/user/target-systems/monitors');
    commit('setMonitors', data);
  },
  async fetchTargets({ commit }) {
    const { data } = await api.get('/motlet-data/targets');
    commit('setTargets', data);
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
